/**
 * @module mapbs.components.reportpanel.egtsingle.egtsinglemodal.egtsinglemodal
 */

import angular from 'angular';
import Egtinfo from 'mapbs/components/reportpanel/egtsingle/data/egtinfo.js';
import mapbsEgtsingleDisplay from 'mapbs/components/reportpanel/egtsingle/egtsingledisplay/egtsingledisplay.js';

const moduleEgtsinglemodal = angular.module('mapbsEgtsinglemodalModule', [
    mapbsEgtsingleDisplay.name,
]);

moduleEgtsinglemodal.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put(
            'mapbs/egtsinglemodal',
            require('./egtsinglemodal.html')
        );
    }
);

/**
 * @ngdoc component
 * @type {!angular.Component}
 */
const EgtsingleModal = {
    controller: 'mapbsEgtsingleModalController as ctrl',
    templateUrl: () => 'mapbs/egtsinglemodal',
    bindings: {
        'egtRealEstate': '<mapbsEgtsingleModalRealestate',
        'rendercaptcha': '<mapbsEgtsingleModalShowcaptcha',
        'egtinfotext': '<mapbsEgtsingleModalEgtinfo',
        'showegt': '=mapbsEgtsingleModalShowegtmodal',
    },
};

/** register component in module */
moduleEgtsinglemodal.component('mapbsEgtsingleModal', EgtsingleModal);

class EgtSingleModalController {
    /**
   * @constructor
   * @private
   *
   * @ngInject
   */
    constructor($scope) {
        this.scope = $scope;

        this.egtRealEstate = {};

        /**
         * indicates whether to display the eigentumsauskunft or not
         * @type {boolean}
         *
         */
        this.showegt = false;

        /** @type {boolean}  */
        this.rendercaptcha = false;

        /** @type {string}  */
        this.egtinfotext = '';

        this.scope.$watch(
            () => {
                return this.egtRealEstate;
            },
            (val) => {
                if (val ) {
                    this.initEgtDisplay();
                }
            }
        );
        this.scope.$watch(
            () => {
                return this.egtinfotext;
            },
            (val) => {
                if (val ) {
                    this.initEgtDisplay();
                }
            }
        );
    }

    /**
   * decide what to display
   * @private
   */
    initEgtDisplay() {
        if (this.egtRealEstate && this.egtinfotext){
            const ein = new Egtinfo();
            ein.sektion = /** @type {string} */ (this.egtRealEstate['sectionNumber']);
            ein.parzellennummer = /** @type {string} */ (this.egtRealEstate['parcelNumber']);
            ein.egtinfotext = this.egtinfotext;
            this.egtinfo = ein;
        }
    }

}

moduleEgtsinglemodal.controller('mapbsEgtsingleModalController', EgtSingleModalController);

export default moduleEgtsinglemodal;
